import { Component, OnInit } from '@angular/core'
import { RouterLink } from '@angular/router'

import { BaseComponent, SwpppDashboard } from '../../shared'

@Component({
    selector: 'app-swppp-dashboard',
    templateUrl: './swppp-dashboard.component.html',
    standalone: true,
    imports: [RouterLink],
})
export class SwpppDashboardComponent extends BaseComponent implements OnInit {
    days = 30
    metrics: SwpppDashboard = emptyDashboard()
    loadError = false

    ngOnInit() {
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'swpppDashboard',
            true,
            this.services.data.get<SwpppDashboard>('/api/SwpppSite/GetDashboardMetrics?days=' + this.days).subscribe({
                next: result => {
                    this.metrics = result ?? emptyDashboard()
                    this.loadError = false
                    this.initialLoadingComplete()
                },
                error: () => {
                    this.metrics = emptyDashboard()
                    this.loadError = true
                    this.initialLoadingComplete()
                },
            }),
        )
    }

    setDays(days: number) {
        this.days = days
        this.refresh()
    }
}

function emptyDashboard(): SwpppDashboard {
    return {
        dueInspections: 0,
        missedInspections: 0,
        openActionItems: 0,
        lateActionItems: 0,
        recentWeatherEvents: 0,
        permitsExpiring: 0,
        permitsExpired: 0,
        sitesMissingPermit: 0,
        sitesMissingPlan: 0,
        sitesMissingMap: 0,
        rows: [],
    }
}
